import React from 'react';
import Cookies from 'universal-cookie';

class Password extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      password: "",
      formSubmitted: false,
      invalidPassword: false
    }
  }
  handleTextChange = (event, nameOfTextbox) => {
    this.setState({
      [nameOfTextbox]: event.target.value,
      invalidPassword: false
    });
  }

  verifyPassword = () => {
    this.setState({formSubmitted: true}, () => {
      if(this.state.password === 'himalaya') {
        const cookies = new Cookies();
        cookies.set('isAuthenticated', true, { path: '/', expires: new Date(Date.now()+3600000) });
        this.props.routeProps.history.push("/discount");
      } else {
        if(this.state.password.trim().length > 0) {
          this.setState({invalidPassword: true});
        }
      }
    })
  }

  render() {
    return (
      <div className="password-container">
        <h1>Please enter password</h1>
        <input type="password"
          className={this.state.formSubmitted && (this.state.password.trim().length <= 0 || this.state.invalidPassword) ? 'errorInput' : ''}
          value={this.state.password}
          onChange={(e) => { this.handleTextChange(e, 'password') }} />
        {this.state.formSubmitted && this.state.password.trim().length <=0 && <div className="errorMessage">Password is required.</div>}
        {this.state.formSubmitted && this.state.password.trim().length > 0 && this.state.invalidPassword && <div className="errorMessage">Password is invalid.</div>}

        <div className="save-btn-wrapper">
          <button onClick={() => { this.verifyPassword() }} className="btn-custom-primary" >
            Log in
          </button>
        </div>
      </div>
    )
  }
}

export default Password;